import { css } from 'styled-components';

import { media } from './media';
import { pxToRem } from './units';

export type ResponsiveSizes = {
  mobile: number;
  desktop: number;
};

type ResponsiveInterpolationFunction<P> = (props: P) => ResponsiveSizes;

type ResponsiveInterpolation<P> =
  | ResponsiveSizes
  | ResponsiveInterpolationFunction<P>;

type ResponsiveInterpolations<P> = ResponsiveInterpolation<P>[];

const computeSizes = <P>(
  interpolation: ResponsiveInterpolation<P>,
  props: P
): ResponsiveSizes => {
  if (typeof interpolation === 'function') {
    return interpolation(props);
  }

  return interpolation;
};

const mapInterpolation =
  <P>(breakpoint: 'mobile' | 'desktop', props: P) =>
  (i: ResponsiveInterpolation<P>): string => {
    const sizes = computeSizes(i, props);

    return pxToRem(sizes[breakpoint]);
  };

const createResponsiveStyles =
  <P extends object>(
    breakpoint: 'mobile' | 'desktop',
    strings: TemplateStringsArray,
    interpolations: ResponsiveInterpolations<P>
  ) =>
  (props: P) =>
    css(strings, ...interpolations.map(mapInterpolation(breakpoint, props)));

export const responsive = <P extends object>(
  strings: TemplateStringsArray,
  ...interpolations: ResponsiveInterpolations<P>
) => css`
  ${createResponsiveStyles('mobile', strings, interpolations)}

  ${media({ from: 'tablet' })`
    ${createResponsiveStyles('desktop', strings, interpolations)}
  `}
`;
